"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringNode = void 0;
const Node_1 = require("./Node");
const utils_1 = require("../utils");
const DataModel_1 = require("../model/DataModel");
const isEnum = (value) => {
    return !!(value === null || value === void 0 ? void 0 : value.enum);
};
const isValidator = (value) => {
    return !!(value === null || value === void 0 ? void 0 : value.validator);
};
/**
 * Simple string node with one text field
 */
const StringNode = (collections, config) => {
    const getValues = () => {
        var _a, _b, _c, _d;
        if (isEnum(config)) {
            if (typeof config.enum === 'string') {
                return (_a = collections === null || collections === void 0 ? void 0 : collections.get(config.enum)) !== null && _a !== void 0 ? _a : [];
            }
            return config.enum;
        }
        if ((config === null || config === void 0 ? void 0 : config.validator) === 'resource') {
            if (typeof config.params.pool === 'string') {
                if (config.params.requireTag) {
                    return (_b = collections === null || collections === void 0 ? void 0 : collections.get(`tag/${config.params.pool}`).map(e => `#${e}`)) !== null && _b !== void 0 ? _b : [];
                }
                const registry = config.params.pool.replace(/^\$/, '');
                const values = (_c = collections === null || collections === void 0 ? void 0 : collections.get(registry)) !== null && _c !== void 0 ? _c : [];
                return [
                    ...config.params.allowTag ? (_d = collections === null || collections === void 0 ? void 0 : collections.get(`tag/${registry}`).map(e => `#${e}`)) !== null && _d !== void 0 ? _d : [] : [],
                    ...config.params.suffix ? values.map(v => v + config.params.suffix) : values,
                ];
            }
            return config.params.pool;
        }
        return [];
    };
    return {
        ...Node_1.Base,
        type: () => 'string',
        default: () => '',
        validate(path, value, errors, options) {
            if (options.loose && typeof value !== 'string') {
                value = (options.wrapLists ? DataModel_1.DataModel.wrapLists(this.default()) : this.default()) || undefined;
            }
            if (typeof value !== 'string') {
                errors.add(path, 'error.expected_string');
                return value;
            }
            if (isValidator(config)) {
                if (config.validator === 'resource' && value.length > 0 && !value.includes(':')) {
                    value = value.startsWith('#')
                        ? '#minecraft:' + value.slice(1)
                        : 'minecraft:' + value;
                }
                if (config.validator === 'resource' && typeof value == 'string') {
                    let id = value;
                    if (value.startsWith('#')) {
                        if (typeof config.params.pool === 'string' && config.params.pool.startsWith('$tag/')) {
                            errors.add(path, 'error.disallowed_tag_prefix');
                            return value;
                        }
                        else if (!config.params.allowTag && !config.params.requireTag) {
                            errors.add(path, 'error.disallowed_tag');
                            return value;
                        }
                        id = id.slice(1);
                    }
                    else if (config.params.requireTag) {
                        errors.add(path, 'error.expected_tag');
                        return value;
                    }
                    if (!id.match(/^(?:[_\-a-z0-9.]*:)?[_\-a-z0-9/.]*$/g)) {
                        errors.add(path, 'error.invalid_resource_location');
                        return value;
                    }
                    if (config.params.suffix && !id.endsWith(config.params.suffix)) {
                        errors.add(path, 'error.expected_suffix', config.params.suffix);
                        return value;
                    }
                }
                if (config.validator === 'resource' && ((typeof config.params.pool === 'string' && config.params.pool.startsWith('$')) ||
                    ((config.params.allowTag || config.params.requireTag) && value.startsWith('#')) ||
                    (typeof value === 'string' && value.includes(':') && !value.startsWith('minecraft:')) ||
                    config.params.isDefinition ||
                    config.params.allowUnknown)) {
                    return value;
                }
            }
            if ((isEnum(config) && config.additional)) {
                return value;
            }
            const values = getValues();
            if (values.length > 0 && !values.includes(value)) {
                errors.add(path, 'error.invalid_enum_option', value);
            }
            return value;
        },
        suggest: () => getValues().map(utils_1.quoteString),
        validationOption() {
            return isValidator(config) ? config : undefined;
        },
        hook(hook, path, ...args) {
            var _a;
            return ((_a = hook.string) !== null && _a !== void 0 ? _a : hook.base).call(hook, { node: this, getValues, config }, path, ...args);
        }
    };
};
exports.StringNode = StringNode;
